<template>
	<div class="binding-body">
		<div class="tip-box" v-if="copyFlag === 2">
			<el-tooltip class="item" effect="dark" content="例：客户1绑定私密商品A、B，客户2，私绑定私密商品C；选择客户2进行同步，同步成功后客户2绑定私密商品A、B" placement="top-start">
				<i class="el-icon-warning"></i>
			</el-tooltip>
		</div>
		<div class="info-box" v-if="copyFlag === 2">
			将该客户的全部私密商品与下方选择的客户的私密商品完全保持一致
		</div>
		<div class="search-box">
			<div class="input-box">
				<span>客户类别：</span>
                <el-select v-model="customercategoryid" class="name-input" size='mini'>
                    <el-option :value="item.ccid" :label="item.ccname" :key="item.ccid" v-for="item in categoryList"></el-option>
                </el-select>
			</div>
            <div class="input-box">
				<span>客户名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入客户名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>线路：</span>
				<el-input
					v-model="lineName"
					placeholder="请输入线路名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>客户状态：</span>
                <el-select v-model="disabledflag" class="name-input" size='mini'>
                    <el-option :value="2" label="全部"></el-option>
                    <el-option :value="0" label="启用"></el-option>
                    <el-option :value="1" label="停用"></el-option>
                </el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					@click="search">查询</el-button>
					<el-button
						class="search-btn"
						size="mini"
						plain
						@click="clearSearch">清空</el-button>
			</div>
		</div>
		<div class="binding-plan-box">
			<div class="plan-row">
				<span>方案名称：</span>
				<el-input
					v-model="planName"
					class="plan-input"
					placeholder="请输入方案名称"
					size="mini">
				</el-input>
			</div>
			<div class="plan-row">
				<span>选择方案：</span>
				<el-select
					v-model="planId"
					@change="planChange"
					clearable
					placeholder="请选择方案"
					class="plan-input"
					size="mini">
					<el-option
						v-for="(item) in planOptions"
						:key="item.id"
						:label="item.schemename"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="plan-btn-row">
				<el-button
					size="mini"
					class="plan-btn"
					type="primary"
					@click="savePlan('0')">另存为方案</el-button>
				<el-button
					size="mini"
					class="plan-btn"
					type="primary"
					:disabled="!planId"
					@click="savePlan">保存编辑</el-button>
				<el-button
					size="mini"
					class="plan-btn"
					plain
					:disabled="!planId"
					@click="delPlan">删除方案</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="table-box">
				<div class="select-title">请选择客户</div>
				<el-table
					:stripe='true'
					ref='multipleTable'
					class="grid-content"
					:data="tableData"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
						<el-table-column
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							prop="customerCategoryName"
							label="客户类别"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="customerName"
							label="客户名称"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="linename"
							label="线路"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="disabledflag"
							label="客户状态"
							align="center"
							min-width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.disabledflag === true">停用</span>
								<span v-else>启用</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="page-box">
						<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="page.number"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="page.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
			<div style="margin-left: 20px;" class="table-box">
				<div class="select-title">已选择客户：{{this.ids.length}}人</div>
				<el-table
					:stripe='true'
					ref='multipleTable1'
					class="grid-content"
					:data="ids"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange1"
					@select-all="handleSelectionChange1">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="customerCategoryName"
						label="客户类别"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="customerName"
						label="客户名称"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="linename"
						label="线路"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="客户状态"
						align="center"
						min-width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.disabledflag === true">停用</span>
							<span v-else>启用</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="binding-foot">
			<el-button class="btn" plain type="primary" size='small' @click="cancelClick">取消</el-button>
			<el-button class="btn" plain type="primary"  size='small' v-if="copyFlag === 1" @click="saveCopyClick">确认添加</el-button>
			<el-button class="btn" plain type="primary"  size='small' v-if="copyFlag === 2" @click="saveSynchroClick">确认添加</el-button>
			<el-button class="btn" plain type="primary"  size='small' v-if="copyFlag === 3" @click="saveScheme">确认添加</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'copyModal',
	props: {
		copyModal: Boolean,
		isRelationship: Boolean,
		ppIds: Array,
		syscode: String,
		customerName: String,
		customerid: String,
		copyFlag: Number
	},
	data () {
		return {
			name: '',
			disabledflag: 2,
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			customerids: [],
			tableHeight: '100%',
			customercategoryid: -1,
			categoryList: [],
			allObj: [{ ccname: '全部', ccid: -1 }],
			lineName: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'customerid'
			}),
			planName: '',
			planId: '',
			planOptions: []
		}
	},
	watch: {
		copyModal: {
			handler (val) {
				if (val) {
					this.tableSelectUtils.clear()
					this.tableReload()
				}
			},
			immediate: true
		}
	},
	created () {
		this.getTreeData()
		this.getPlan()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
			})
		},
		handleSelectionChange1 (data) {
			this.tableSelectUtils.selectToggle(this.ids, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
			})
		},
		getTreeData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.categoryList = this.allObj.concat(res.data.childNode)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getPlan () {
			let params = {
				type: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.planOptions = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		savePlan (type) {
			if (!this.planName) {
				this.$message.error('请输入方案名称')
				return false
			}
			if (this.ids.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			const names = this.planOptions.map(item => {
				return item.schemename
			})

			if (names.indexOf(this.planName) !== -1 && type === '0') {
				this.$message.error('方案名称重复')
				return false
			}
			const details = this.ids.map(item => {
				return {
					customerId: item.customerid
				}
			})
			let params = {
				type: 0,
				customerSchemeName: this.planName,
				customerSchemeDetails: details
			}
			if (this.planId && type !== '0') {
				params.customerSchemeId = this.planId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/savaOrUpdateCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getPlan()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		delPlan () {
			let params = {
				customerSchemeId: this.planId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/removeCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getPlan()
					this.planName = ''
					this.planId = ''
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		planChange (e) {
			if (e) {
				const detail = this.planOptions.filter(item => {
					return e === item.id
				})[0]
				this.planName = detail.schemename
				this.planId = detail.id
				detail.detail.forEach(item => {
					item.customerid = item.customerId
				})
				this.tableSelectUtils.selectToggle(this.tableData, detail.detail)
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
				})
			} else {
				this.planName = ''
				this.planId = ''
				this.tableSelectUtils.clear()
				this.tableReload()
			}
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveCopyClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			let params = {}
			let url = ''
			let customerids = []
			let syscodeids = []
			let logArr = []
			this.ids.forEach(item => {
				syscodeids.push(item.syscodeid)
				customerids.push(item.customerid)
				logArr.push(`客户：${item.customerName}”`)
			})
			let list = []
			let list1 = []
			let pName = []
			this.ppIds.forEach(item => {
				list.push(item.id)
				list1.push({ productid: item.id, shopid: item.shopid })
				console.log(item)
				let text = `”客户：${item.customerName}”绑定的【”私密商品：${item.pname}”，“销售门店：${item.shopname}”】`
				pName.push(text)
			})
			if (this.isRelationship) {
				url = `${this.$fxBaseApi.urlQIVShop}/customer/copycustomers`
				params = {
					productShopDTOS: list1,
					customerIds: customerids.join(','),
					syscodeids: syscodeids.join(','),
					customerId: this.customerid
				}
			} else {
				url = `${this.$fxBaseApi.urlQIVShop}/customer/copyProductPriceToOtherCustoemr`
				params = {
					ppIds: list.join(','),
					sysIds: syscodeids.join(',')
				}
			}
			let changeData = {
				info: '将' + pName.join(',') + '复制到' + logArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: url,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.tableReload()
					this.$message.success('添加成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveSynchroClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			this.$confirm('同步到其他客户是将其他客户的私密商品与该客户的私密商品完全保持一致，确定继续操作？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: '',
				closeOnClickModal: false
			}).then(() => {
				// this.saveSchemeSynchroClick()
				let params = {}
				let url = ''
				let customerids = []
				let syscodeids = []
				let logArr = []
				this.ids.forEach(item => {
					syscodeids.push(item.syscodeid)
					customerids.push(item.customerid)
					logArr.push(`”客户：${item.customerName}”`)
				})
				url = `${this.$fxBaseApi.urlQIVShop}/customer/synchronizationCustomerProductToOtherCustomer`
				params = {
					custoemrId: this.customerid,
					operatedCustomerIds: customerids,
					operatedSyscodeIds: syscodeids
				}
				let changeData = {
					info: `将”客户：${this.customerName}”绑定的“全部私密商品”同步到` + logArr.join(',')
				}
				const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
				this.$store.dispatch('requestPost', {
					url: url,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.tableReload()
						this.$message.success('同步成功！')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {
			})
		},
		saveScheme () {
			if (this.ids.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			this.$confirm('同步到其他客户是将其他客户的订货方案与该客户的订货方案完全保持一致，确定继续操作？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: '',
				closeOnClickModal: false
			}).then(() => {
				this.saveSchemeSynchroClick()
			}).catch(() => {
			})
		},
		saveSchemeSynchroClick () {
			let params = {}
			let url = ''
			let customerIds = []
			let logArr = []
			this.ids.forEach(item => {
				customerIds.push(item.customerid)
				logArr.push(item.customerName)
			})
			url = `${this.$fxBaseApi.urlQIVShop}/customer/synchronizationOrderGoodsDate`
			params = {
				customerId: this.customerid,
				customerIds: customerIds
			}
			let changeData = {
				pre: { synchroGoodsData: {} },
				cur: { synchroGoodsData: { logArr: logArr, customerName: this.customerName } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			this.$store.dispatch('requestPost', {
				url: url,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.tableReload()
					this.$message.success('同步成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearSearch () {
			this.customercategoryid = -1
			this.name = ''
			this.lineName = ''
			this.disabledflag = 2
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		search () {
			// this.tableSelectUtils.clear()
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		tableReload () {
			let params = {
				name: this.name,
				delSyscode: this.syscode,
				disabledflag: this.disabledflag,
				page: this.page.number,
				size: this.page.size,
				customercategoryid: this.customercategoryid,
				keyword: this.lineName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerOfCopy`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.data
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					})
					this.total = +res.data.count
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :100%;
	flex-direction: column;
    height :600px;
	position: relative;
	.tip-box{
		display: inline-block;
		position: absolute;
		top: -44px;
		left: 145px;
		font-size: 18px
	}
	.info-box{
		margin-bottom: 10px;
		color: red;
		text-align: left
	}
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :160px;
		}
		.input-box{
			// margin-left :10px;
			width :220px;
			margin-bottom:10px
			.name-input {
				width: 140px;
				margin-right: 10px;
			}
			.select-box{
				width:100px;
				margin-right:10px;
			}
		}
	}
	.binding-plan-box {
		display: flex;
		align-items: center
		margin-bottom: 10px
		.plan-row {
			display: flex;
			align-items: center
			width: 220px;
			.plan-input {
				width: 140px;
			}
		}
		.plan-btn-row {
			margin-left: 10px;
			.plan-btn {
				width:100px
			}
		}
	}
	.table-container{
		display: flex;
		box-sizing: border-box
		flex-direction: row
		height:calc(100% - 110px);
	}
	.page-box{
		margin-top: 5px
	}
	.grid-content{
		height: calc(100% - 70px) !important
	}
	.table-box{
		height: 100%;
		width: calc(50% - 10px)
	}
	.select-title{
		line-height: 30px;
		text-align: left
	}
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
.cell{
	padding: 0 !important
}
</style>
